
import React, { useState, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { shareToFB, shareToLine, copyLink } from '../../utils/socialMediaShare';
import { getSlugByPathname } from '../../utils/methods';

import './index.scss';

import DetailPageLayout from '../../components/DetailPageLayout';
import { Facebook, Line, Copy, Check } from '../../components/Icons';
import Link from '../../components/Link';
import BlogCard from '../../components/BlogCard';
import SNSPanel from '../../components/SNSPanel';


const BlogPage = ({ wording }) => {
    const _w = wording;
    const [article, setArticle] = useState(null);

    const articleRef = useRef();

    const getArticle = async (slug) => {
        const res = await Axios.get(`/api/blog/${slug}`);
        setArticle(res.data);
    }

    useEffect(() => {
        const slug = getSlugByPathname("blog");
        getArticle(slug)
    }, []);

    useEffect(() => {
        if (!article) return;

        const allLinks = articleRef.current.querySelectorAll('a')
        allLinks.forEach((link) => {
            link.addEventListener('click', e => {
                const href = e.currentTarget.getAttribute('href')
                if (href.startsWith('#')) {
                    e.preventDefault();
                    window.history.pushState(null, null, href);
                    document.getElementById(href.replace('#', ''))?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                }
            });
        });


    }, [article]);

    if (!article) return null;

    const { cover_image, title, release_date, update_date, category, content, tags, related } = article;

    const parsedTime = release_date.split("T")[0].replace(/-/gi, ".");
    const parsedUpdateTime = update_date?.split("T")[0].replace(/-/gi, ".");

    return (
        <React.Fragment>
            <Helmet>
                <title>{title + '｜' + _w.meta_title}</title>
            </Helmet>
            <DetailPageLayout backLink="/blog" className="blog-page">
                <SNSPanel />
                <div className="wrapper">
                    <img className="cover js-banner" src={"/" + cover_image} alt={title} />
                    <div className="meta">
                        <h1>{title}</h1>
                        <div className="detail">
                            <div>
                                <span className="category">{category.name}</span>
                                <span className="time">{parsedTime}</span>
                                <div className="br"/>
                                {parsedUpdateTime && (
                                    <>
                                        <span className="category">更新時間</span>
                                        <span className="time">{parsedUpdateTime}</span>
                                    </>
                                )}
                            </div>
                            <div className="shares">
                                <button onClick={shareToFB}>
                                    <Facebook />
                                </button>
                                <button onClick={shareToLine}>
                                    <Line />
                                </button>
                                <CopyButton />
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <article dangerouslySetInnerHTML={{ __html: content }} ref={articleRef} />
                        {tags?.length > 0 && <div className="tags">
                            <span>相關字詞：</span>
                            <div>
                                {tags.map((keyword, index) => (
                                    index !== tags.length - 1 ? (
                                        <>
                                            <Link key={index} to={`/blog?tag=${keyword.id}`}>{keyword.name}</Link>
                                            <span>、</span>
                                        </>
                                    ) : <Link key={index} to={`/blog?tag=${keyword.id}`}>{keyword.name}</Link>
                                ))}
                            </div>
                        </div>}
                        <Link to="/blog" className="back-link">
                            BACK TO BLOG
                        </Link>
                    </div>
                    {related?.length > 0 && (
                        <div className="others">
                            <h3>OTHER POSTS</h3>
                            <div className="list">
                                {related.map((post, id) => (
                                    <BlogCard key={id} blog={post} />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </DetailPageLayout>
        </React.Fragment>
    )
}

const CopyButton = () => {
    const [isCopied, setIsCopied] = useState(false);
    const timer = useRef();

    const handleCopyLink = (e) => {
        if (timer.current) return;

        const onComplete = () => {
            setIsCopied(true);
            timer.current = window.setTimeout(() => {
                setIsCopied(false);

                window.clearTimeout(timer.current);
                timer.current = null;
            }, 2000);
        }

        copyLink(e, onComplete);

    }

    return (
        <button onClick={handleCopyLink}>
            {isCopied ? <Check /> : <Copy />}
        </button>
    )
}

export default BlogPage;
